/** Desktop writing-mode controls panel — pure state helpers (testable without React). */

export const PANEL_HOVER_OPEN_DELAY_MS = 175
export const PANEL_CLOSE_GRACE_MS = 2750
export const PANEL_DISMISS_KEYSTROKES = 3

export function initialPanelState() {
  return {
    open: false,
    pinned: false,
    valueChangingKeystrokes: 0,
  }
}

/**
 * Reduce panel chrome state.
 * Actions: open | close | pin | unpin | togglePin | outsideClick | valueChangingKeystroke | reset
 */
export function reducePanelState(state, action) {
  const base = state || initialPanelState()

  switch (action?.type) {
    case 'open':
      return { ...base, open: true, valueChangingKeystrokes: 0 }

    case 'close':
      return initialPanelState()

    case 'pin':
      return { open: true, pinned: true, valueChangingKeystrokes: 0 }

    case 'unpin':
      return { ...base, pinned: false }

    case 'togglePin':
      if (base.pinned) {
        return { ...base, pinned: false }
      }
      return { open: true, pinned: true, valueChangingKeystrokes: 0 }

    case 'outsideClick':
      return initialPanelState()

    case 'valueChangingKeystroke': {
      if (!base.open || base.pinned) {
        return base
      }
      const next = base.valueChangingKeystrokes + 1
      if (next >= PANEL_DISMISS_KEYSTROKES) {
        return initialPanelState()
      }
      return { ...base, valueChangingKeystrokes: next }
    }

    case 'reset':
      return initialPanelState()

    default:
      return base
  }
}

/**
 * Layered Esc: panel open/pinned closes panel only; otherwise exit writing mode.
 * @returns {{ panel: object, exitWritingMode: boolean }}
 */
export function handlePanelEscape(panelState) {
  const state = panelState || initialPanelState()
  if (state.open || state.pinned) {
    return { panel: initialPanelState(), exitWritingMode: false }
  }
  return { panel: state, exitWritingMode: true }
}

/**
 * Whether the pointer is inside the upper-left hover quadrant of the shell.
 * Quadrant: left half × top half of the shell bounding box.
 */
export function isUpperLeftQuadrant(clientX, clientY, shellRect) {
  if (!shellRect) return false
  const midX = shellRect.left + shellRect.width / 2
  const midY = shellRect.top + shellRect.height / 2
  return clientX < midX && clientY < midY
}
